import { DOCUMENT_ISSUER_LENGTH } from '../../../../constants/requisitesLength';
import { checkMaxLength } from '../../../../helpers/validators';
export const checkIssuerMaxLegth = ({ value }) => {
    return checkMaxLength({ value, length: DOCUMENT_ISSUER_LENGTH });
};
